module.exports = __webpack_public_path__ + "img/art4.7d366b40.png";